module.exports = __webpack_public_path__ + "img/search_icone.55e43727.svg";